// Нормализованная форма состояния стора (SPEC §4.3) + чистые помощники упорядочивания по seq.
// Состояние — без вложенных копий, всё по id; единственный источник порядка ленты — `orderedSeq`
// (инвариант 1: порядок по seq, НЕ по времени прихода события).
export function initialState() {
    return {
        chats: { byId: {}, order: [] },
        messages: { byChat: {} },
        messageIndex: {},
        presence: {},
        typing: {},
        receipts: {},
        drafts: {},
        draftDirty: {},
        unread: {},
        serverTotalUnread: undefined,
        activeChats: {},
        conn: { status: 'connecting', needRelogin: false, needReload: false },
        users: {},
    };
}
export function emptyChatMessages() {
    return {
        bySeq: {},
        orderedSeq: [],
        optimistic: {},
        optimisticOrder: [],
        maxSeq: 0,
        gapBelow: true,
    };
}
/** Получить (создав при отсутствии) контейнер сообщений чата. Мутирует переданное состояние. */
export function ensureChatMessages(state, chatId) {
    let cm = state.messages.byChat[chatId];
    if (!cm) {
        cm = emptyChatMessages();
        state.messages.byChat[chatId] = cm;
    }
    return cm;
}
/**
 * Бинпоиск позиции seq в ВОЗРАСТАЮЩЕМ массиве. Возвращает {index, found}:
 * found=true → seq уже присутствует (index — его позиция); found=false → index = точка вставки.
 * Это машинная защита инвариантов 1/2: вставка идемпотентна, дубля в orderedSeq не возникает.
 */
export function locateSeq(orderedSeq, seq) {
    let lo = 0;
    let hi = orderedSeq.length;
    while (lo < hi) {
        const mid = (lo + hi) >>> 1;
        const v = orderedSeq[mid];
        if (v === seq)
            return { index: mid, found: true };
        if (v < seq)
            lo = mid + 1;
        else
            hi = mid;
    }
    return { index: lo, found: false };
}
/** Вставить seq на правильную позицию (по возрастанию), если его ещё нет. Идемпотентно. */
export function insertSeqOrdered(orderedSeq, seq) {
    const { index, found } = locateSeq(orderedSeq, seq);
    if (!found)
        orderedSeq.splice(index, 0, seq);
}
//# sourceMappingURL=state.js.map